import cn from 'classnames';

import { IConDefaultType } from '../types';

interface IStudioBackgroundIconProps extends IConDefaultType {}

export default function StudioBackgroundIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  style,
}: IStudioBackgroundIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 3C3.79086 3 2 4.79086 2 7V12C2 13.6569 3.34315 15 5 15H8.77164L8.33743 18.9079C8.09488 21.0909 9.80364 23 12 23C14.1964 23 15.9052 21.0909 15.6626 18.9079L15.2284 15H19C20.6569 15 22 13.6569 22 12V4C22 3.44772 21.5523 3 21 3H6ZM14.1162 13C13.5205 13 13.057 13.5174 13.1222 14.1094L13.6748 19.1288C13.7858 20.127 13.0044 21 12 21C10.9957 21 10.2143 20.127 10.3252 19.1288L10.8778 14.1094C10.943 13.5174 10.4795 13 9.88385 13H5C4.44772 13 4 12.5523 4 12V7C4 5.89543 4.89543 5 6 5H19.5C19.7761 5 20 5.22386 20 5.5V12C20 12.5523 19.5523 13 19 13H14.1162Z"
          fill={color || '#8A8A8A'}
        />
        <rect x="16" y="4" width="2" height="3" rx="1" fill={color || '#8A8A8A'} />
        <rect x="4" y="9" width="16" height="2" fill={color || '#8A8A8A'} />
      </svg>
    </i>
  );
}
